const getters = {
    deliverynotes: (state) => state.deliverynotes,
    signature: (state) => state.signature,
    deliverynotesByInvoice: (state) => state.deliverynotesByInvoice,
    signatureid: (state) => state.signatureid,
    loading: state => state.loading
};

export default getters;